import React from 'react';
import { IIconProps } from './utils';

export const Search = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M18.8611 18.8611C22.3179 15.4042 22.3179 9.79951 18.8611 6.34265C15.4042 2.88578 9.79951 2.88578 6.34265 6.34265C2.88578 9.79951 2.88578 15.4042 6.34265 18.8611C9.79951 22.3179 15.4042 22.3179 18.8611 18.8611ZM18.8611 18.8611L22.7182 22.7182M22.7182 22.7182L22.9034 22.5331C23.1504 22.2861 23.5507 22.2861 23.7976 22.5331L26.0648 24.8003C26.3117 25.0472 26.3117 25.4475 26.0648 25.6944L25.6944 26.0648C25.4475 26.3117 25.0472 26.3117 24.8003 26.0648L22.5331 23.7976C22.2861 23.5507 22.2861 23.1504 22.5331 22.9034L22.7182 22.7182Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
